import {Injectable} from '@angular/core';
import {Article} from '../../core/models/articles/articles.model';
import {User} from '../../core/models/users/users.model';
import {ToastService} from '../../core/services/toast/toast.service';
import {UsersService} from '../../core/services/users/users.service';

@Injectable({
  providedIn: 'root',
})
export class ArticleFavoriteService {
  constructor(
    private usersService: UsersService,
    private toastService: ToastService,
  ) {
  }

  addFavorite(user: User & { favArticles?: string[] }, article: Article) {
    (user.favArticles ??= []).push(article._id);
    this.usersService.updateOne(user._id, {
      favArticles: user.favArticles,
    }, []).subscribe({
      next: newUser => {
        user.favArticles = newUser.favArticles as string[];
        this.toastService.success(
          $localize`:@@article-favorite-added-title:Favorit hinzugefügt`,
          $localize`:@@article-favorite-added-message:Der Artikel wurde zu Ihren Favoriten hinzugefügt.`,
        );
      },
      error: error => this.toastService.error(
        $localize`:@@article-favorite-added-error-title:Favorit nicht hinzugefügt`,
        $localize`:@@article-favorite-added-error-message:Der Artikel konnte nicht zu Ihren Favoriten hinzugefügt werden.`,
        error,
      ),
    });
  }

  removeFavorite(user: User & { favArticles?: string[] }, article: Article) {
    if (!user.favArticles) {
      return;
    }

    user.favArticles = user.favArticles.filter(a => a !== article._id);
    this.usersService.updateOne(user._id, {
      favArticles: user.favArticles,
    }, []).subscribe({
      next: newUser => {
        user.favArticles = newUser.favArticles as string[];
        this.toastService.warning(
          $localize`:@@article-favorite-removed-title:Favorit entfernt`,
          $localize`:@@article-favorite-removed-message:Der Artikel wurde aus Ihren Favoriten entfernt.`,
        );
      },
      error: error => this.toastService.error(
        $localize`:@@article-favorite-removed-error-title:Favorit nicht entfernt`,
        $localize`:@@article-favorite-removed-error-message:Der Artikel konnte nicht aus Ihren Favoriten entfernt werden.`,
        error,
      ),
    });
  }
}
